import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Phone from '@mui/icons-material/PhoneAndroidTwoTone';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  FormGroup,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';



const ContactForm = () => {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Coleta os dados do formulário
    const formData = new FormData(formRef.current);

    const data = {
      fromName: formData.get('user_name'),
      fromEmail: formData.get('user_email'),
      phone: formData.get('user_phone'),
      projectType: formData.getAll('project_type'),
      projectSize: formData.get('project_size'),
      startDate: formData.get('start_date'),
      budget: formData.get('budget'),
      location: formData.get('location'),
      designPreferences: formData.get('design_preferences'),
      additionalComments: formData.get('additional_comments'),
    };

    try {
      const response = await fetch('api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        navigate('/confirmation');
        formRef.current.reset(); // Reseta o formulário
      } else {
        console.log(response)
        alert('Erro ao enviar o formulário. Tente novamente.');
      }
    } catch (error) {
      console.log(error)
      console.error('Erro ao enviar o formulário:', error);
      alert('Erro ao enviar o formulário. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      id="contact"
      sx={{
        py: 6,
        px: { xs: 2, sm: 4, md: 8 },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'flex-start',
        marginBottom: 10,
      }}
    >
      <Container maxWidth="lg">
        <Grid2 container spacing={4} justifyContent="center">
          {/* Formulário de Contato */}
          <Grid2 item xs={12} md={6}>
            <Typography
              variant="h6"
              sx={{
                color: '#1A7B30',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                marginBottom: 2,
              }}
            >
              Entre em contato
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 4 }}>
              Vamos discutir o seu projeto!
            </Typography>
            <Box
              component="form"
              ref={formRef}
              onSubmit={handleSubmit}
              noValidate
              autoComplete="off"
            >
              <TextField
                fullWidth
                label="Nome"
                name="user_name"
                required
                margin="normal"
                variant="outlined"
              />
              <TextField
                fullWidth
                label="Endereço de Email"
                name="user_email"
                required
                margin="normal"
                variant="outlined"
              />
              <TextField
                fullWidth
                label="Número de Telefone"
                name="user_phone"
                required
                margin="normal"
                variant="outlined"
              />

              {/* Tipo de Projeto */}
              <Typography sx={{ marginTop: 2, marginBottom: 1 }}>
                Qual o tipo de projeto com o qual você precisa de assistência?
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox name="project_type" value="Instalação de pias" />}
                  label="Instalação de pias"
                />
                <FormControlLabel
                  control={<Checkbox name="project_type" value="Instalação de pisos" />}
                  label="Instalação de pisos"
                />
                <FormControlLabel
                  control={<Checkbox name="project_type" value="Construção de casas" />}
                  label="Construção de casas"
                />
                <FormControlLabel
                  control={<Checkbox name="project_type" value="Construção de apartamentos" />}
                  label="Construção de apartamentos"
                />
                <FormControlLabel
                  control={<Checkbox name="project_type" value="Renovação" />}
                  label="Renovação"
                />
              </FormGroup>

              <Box sx={{ marginTop: 2 }}>
                <InputLabel>Tamanho do Projeto</InputLabel>
                <Select name="project_size" fullWidth variant="outlined" defaultValue="">
                  <MenuItem value="Pequeno">Pequeno</MenuItem>
                  <MenuItem value="Médio">Médio</MenuItem>
                  <MenuItem value="Grande">Grande</MenuItem>
                </Select>
              </Box>

              <TextField
                fullWidth
                label="Data de início"
                name="start_date"
                margin="normal"
                variant="outlined"
                type="date"
                InputLabelProps={{ shrink: true }}
              />

              <TextField
                fullWidth
                label="Orçamento"
                name="budget"
                margin="normal"
                variant="outlined"
              />

              <TextField
                fullWidth
                label="Localização"
                name="location"
                margin="normal"
                variant="outlined"
              />

              <TextField
                fullWidth
                label="Preferências de design"
                name="design_preferences"
                margin="normal"
                variant="outlined"
                multiline
                rows={3}
              />

              <TextField
                fullWidth
                label="Comentários adicionais"
                name="additional_comments"
                margin="normal"
                variant="outlined"
                multiline
                rows={3}
              />

              <FormControlLabel
                control={<Checkbox required />}
                label="Permito que este site armazene minha submissão."
                sx={{ alignItems: 'flex-start', marginTop: 2 }}
              />

              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: '#1A7B30',
                  color: '#fff',
                  fontWeight: 'bold',
                  marginTop: 3,
                  ':hover': { backgroundColor: '#145A22' },
                }}
                fullWidth
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Enviar'}
              </Button>
            </Box>
          </Grid2>

          {/* Informações de Contato */}
          <Grid2 item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: '#f9f9f9',
                padding: 3,
                borderRadius: 2,
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                maxWidth: '400px',
                margin: '0 auto',
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Ou envie um email
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                <EmailIcon sx={{ marginRight: 1, color: '#1A7B30' }} />
                <Typography variant="body1">
                  <a
                    href="mailto:thiago.antonio0103@gmail.com"
                    style={{ textDecoration: 'none', color: '#000', fontWeight: 'bold' }}
                  >
                    thiago.antonio0103@gmail.com
                  </a>
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                <LocationOnIcon sx={{ marginRight: 1, color: '#1A7B30' }} />
                <Typography variant="body1">
                  <strong>Localização:</strong> Rio de Janeiro, Brasil
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                <Phone sx={{ marginRight: 1, color: '#1A7B30' }} />
                <Typography variant="body1">
                  <strong>Celular | WhatsApp:</strong> {"(21) 97920-5671"}
                </Typography>
              </Box>
            </Box>
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  );
};

export default ContactForm;